import {IApplicationState} from '../../../types/types';
import {getActiveBoard} from './getActiveBoard';
import {getBoardSharingType} from '../helpers/getBoardSharingType';

export const getActiveBoardSharingType = (state: IApplicationState): string => {
    const activeBoard = getActiveBoard(state);
    return getBoardSharingType(activeBoard);
};
